// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type PlanPackageAiProposalSummaryFragment = { __typename?: 'PlanPackageAiProposal', id: string, createdAt: Types.Scalars['DateTime']['input'], status: { __typename?: 'AiProposalStatusDetail', code: Types.AiProposalStatus }, asset: { __typename?: 'Asset', id: string, fileName?: string | null | undefined, downloadUrl: string }, entityProposals: Array<{ __typename?: 'AiEntityProposal', id: string, type: { __typename?: 'AiEntityProposalTypeDetail', code: Types.AiEntityProposalType }, entityType: { __typename?: 'AiEntityProposalEntityTypeDetail', code: Types.AiEntityProposalEntityType }, fieldProposals: Array<{ __typename?: 'AiFieldProposal', id: string, fieldName: string, status: { __typename?: 'AiFieldProposalStatusDetail', code: Types.AiFieldProposalStatus } }> }> };

export const PlanPackageAiProposalSummaryFragmentDoc = gql`
    fragment PlanPackageAiProposalSummary on PlanPackageAiProposal {
  id
  createdAt
  status {
    code
  }
  asset {
    id
    fileName
    downloadUrl
  }
  entityProposals(entityType: [READY_PLAN_LOCATION, READY_PLAN_PROGRAM_DATA]) {
    id
    type {
      code
    }
    entityType {
      code
    }
    fieldProposals {
      id
      fieldName
      status {
        code
      }
    }
  }
}
    `;